/**
 * Instead of using bootstrap's modal.js, just make a basic modal controller.
 */
define('components/modal',[],function () {
    'use strict';
    var Modal = function($el) {
        this.$el = $el.hide();
        this.closeHandler = this.close.bind(this);
    };

    var proto = Modal.prototype;

    proto.open = function() {
        this.$el.show().addClass('in');
        this.$modalBack = $('<div class="modal-backdrop fade"></div>');
        this.$el.parent().append(this.$modalBack);
        this.$modalBack.addClass('in');
        setTimeout(function() {
            this.$modalBack.on('click', this.closeHandler);
        }.bind(this));
    };

    proto.close = function () {
        this.$el.removeClass('in').hide();
        this.$modalBack.removeClass('in');
        setTimeout(this.$modalBack.remove.bind(this.$modalBack));
    };

    proto.destroy = function () {
        if (this.$modalBack != null) {this.$modalBack.remove();}
        this.$modalBack = null;
        this.$el = null;
    };

    return Modal;
});

